import * as actions from '../actions/types';
import {PROGRAM_ADN} from "../config/constants";

const initialState = {
  step: 1,
  maxStep: 5,
  submitted: false,
  updated: false
};

function setStep(formState, action) {
  return {
    ...formState,
    step: Math.min(action.step, formState.maxStep)
  };
}

function toggleSubmitted(formState) {
  return {
    ...formState,
    submitted: !formState.submitted
  };
}

function applicationSaved(formState) {
  return {
    ...formState,
    updated: false
  }
}

function applicationUpdated(formState) {
  return {
    ...formState,
    updated: true
  }
}

function setApplication(formState, action) {
  return {
    ...formState,
    step: 1,
    updated: false,
    submitted: action.application.status !== 'IN',
    maxStep: action.application.programId === PROGRAM_ADN ? 5 : 4
  }
}

function refreshApplication(formState, action) {
  return {
    ...formState,
    updated: false,
    submitted: action.application.status !== 'IN'
  }
}

function applicationDeleted() {
  return initialState;
}

export const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_STEP:
      return setStep(state, action);
    case 'TOGGLE_SUBMITTED':
      return toggleSubmitted(state, action);
    case actions.UPDATE_APPLICATION_SUCCESS:
      return applicationSaved(state, action);
    case actions.UPDATE_BASIC_INFO:
      return applicationUpdated(state, action);
    case actions.SET_APPLICATION:
      return setApplication(state, action);
    case actions.REFRESH_APPLICATION:
      return refreshApplication(state, action);
    case actions.DELETE_APPLICATION_SUCCESS:
      return applicationDeleted(state, action);
    default:
      return state;
  }
};

export default formReducer;